import React from 'react';
import Grid from '@mui/material/Grid';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Tooltip } from '@mui/material';
import KeyIcon from '@mui/icons-material/Key';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  StyledAccordion,
  AddCredential,
  SecretDescriptionText,
  SecretButton,
  SecretButtonContent,
  KeyIconStyle,
  MoreSecretsText,
  StyledSecretPlaceholder,
} from '../CodeStyle';
import { useNavigate } from 'react-router-dom';

const SecretsSection = ({ availableSecrets, classes, isFreeUserTier, store }) => {
  const isInternetEnabled = store ? store.getState().isInternetEnabledInStore() : false;
  const navigate = useNavigate();

  if (!isInternetEnabled || isFreeUserTier) {
    return null;
  }

  return (
    <StyledAccordion defaultExpanded={false}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="secrets-content"
        id="secrets-header"
      >
        <Grid container alignItems="center">
          <Grid item>
            <div className={classes?.label ?? ''}>Secrets and Credentials</div>
          </Grid>
          <Grid item marginLeft={1} display="flex" alignItems="center">
            {availableSecrets?.length > 0 && (
              <>
                {availableSecrets.slice(0, 2).map((secret, index) => (
                  <Tooltip key={index} title={secret} placement="top">
                    <KeyIconStyle fontSize="small" />
                  </Tooltip>
                ))}
                {availableSecrets.length > 2 && (
                  <MoreSecretsText variant="body2">+{availableSecrets.length - 2}</MoreSecretsText>
                )}
              </>
            )}
          </Grid>
        </Grid>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container item xs={12} rowGap={1}>
          <Grid item xs={12}>
            <SecretDescriptionText>
              Secrets and credentials can be used in your code
            </SecretDescriptionText>
          </Grid>

          {availableSecrets.map((secret, index) => (
            <CopyToClipboard text={secret} key={index}>
              <Tooltip title={secret} placement="top">
                <SecretButton size={'small'} variant={'outlined'} className="secretButton">
                  <Grid container alignItems="center" spacing={1}>
                    <Grid item className="flex-center">
                      <KeyIcon />
                    </Grid>
                    <SecretButtonContent item className="flex-center">
                      <StyledSecretPlaceholder>{secret}</StyledSecretPlaceholder>
                    </SecretButtonContent>
                    <Grid item className="flex-center">
                      <ContentCopyIcon />
                    </Grid>
                  </Grid>
                </SecretButton>
              </Tooltip>
            </CopyToClipboard>
          ))}

          <Grid item xs={12}>
            <AddCredential onClick={() => navigate('/credential_store')}>
              + Add another secret or credential
            </AddCredential>
          </Grid>
        </Grid>
      </AccordionDetails>
    </StyledAccordion>
  );
};

export default SecretsSection;
